import React from 'react';

export default function MissingFontSection({
  missingFontToAdd, // Name of the font to add
  missingFontFile, // File object
  onFileChange, // Function to update file state in parent
  onSubmit, // Function to handle form submission
  onCancel // Function to cancel adding font
}) {

  if (!missingFontToAdd) {
    return null; // Don't render if no font is selected to be added
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!missingFontToAdd || !missingFontFile) return;
    onSubmit(missingFontToAdd, missingFontFile); // Pass data to parent handler
  };

  return (
    <div className="missing-font-section">
      <h4 style={{ marginBottom: 10 }}>
        Dodaj brakującą czcionkę: <em>{missingFontToAdd}</em>
      </h4>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: "10px" }}>
          <label>Plik (TTF/OTF): </label>
          <input
            type="file"
            accept=".ttf,.otf"
            required // Make file input required
            onChange={(ev) => {
              if (ev.target.files && ev.target.files[0]) {
                onFileChange(ev.target.files[0]); // Update parent state
              } else {
                onFileChange(null); // Clear file if selection is cancelled
              }
            }}
          />
        </div>
        <button
          type="submit"
          className="admin-btn admin-btn-save"
          style={{ marginRight: '10px' }}
          disabled={!missingFontFile} // Disable submit if no file selected
        >
          Zapisz
        </button>
        <button
          type="button"
          onClick={onCancel} // Call parent cancel handler
          className="admin-btn admin-btn-cancel"
        >
          Anuluj
        </button>
      </form>
    </div>
  );
}
